import { translationKeys } from '@gik/create/i18n/en';
import i18n from '@gik/i18n';
import moment from 'moment';
import { checkReminder, getReminderTriggerKey, openReminder } from '../Reminder/openReminder';

export enum DonationReminderStorageKeyNames {
  timestamp = 'gik-donations-reminder-triggered-timestamp',
  count = 'gik-donations-reminder-triggered-count',
}

const blockName = 'donations-reminder-modal';

export function openDonationsReminder() {
  function handleAdd() {
    // FIXME: replace this once inkind page migration is done
    document.getElementById('page-settings-page-button-anchor')?.click();
    setTimeout(() => {
      document.getElementById('page-settings-donation-header')?.scrollIntoView();
    }, 300);
  }

  openReminder(
    blockName,
    i18n.t(translationKeys.DonationsReminderTitle),
    i18n.t(translationKeys.DonationsReminderDescription),
    handleAdd
  );
}

/**
 * opens the recipientAddress reminder modal if needed
 */
export function checkDonationsReminder(
  inkindRouteId: string,
  pageCreatedDate: moment.Moment,
  allowMultipleReminders = false
) {
  checkReminder(
    openDonationsReminder,
    'donations-reminder',
    pageCreatedDate,
    getReminderTriggerKey(DonationReminderStorageKeyNames.timestamp, inkindRouteId),
    getReminderTriggerKey(DonationReminderStorageKeyNames.count, inkindRouteId),
    undefined,
    undefined,
    allowMultipleReminders
  );
}
